import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { getLatest } from "@/lib/movies";
import type { MovieType } from "@/types/movie";

type Tab = "all" | MovieType;

const tabs: { key: Tab; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
];

export default function LatestSection() {
  const [tab, setTab] = useState<Tab>("all");

  const list = useMemo(() => {
    if (tab === "all") return getLatest(10);
    return getLatest(10, tab);
  }, [tab]);

  const moreLink = tab === "tv" ? "/category/tv" : "/category/movie";

  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            最新上映
          </h2>
          <p className="mt-1 text-sm text-foreground-500">按更新时间倒序，第一时间掌握新片动态</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 rounded-full bg-background-200 p-1">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  tab === item.key
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          <Link
            to={moreLink}
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-5">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}